import { isNil } from "client/Misc/utils";
import { useMemo } from "react";

export function useParsedValue<TValue>(
	rawValue: string | nil,
	parser: (rawValue: string) => TryResult<TValue>
): OptionalModel<TValue | undefined> {
	return useMemo(
		(): OptionalModel<TValue | undefined> => {
			return getParsedValue(
				rawValue,
				parser
			);
		},
		[
			rawValue,
			parser
		]
	);
}

export function getParsedValue<TValue>(
	rawValue: string | nil,
	parser: (rawValue: string) => TryResult<TValue>
): OptionalModel<TValue | undefined> {
	if (isNil(rawValue)) {
		return {
			isSet: false
		};
	}

	const parseResult: TryResult<TValue> = parser(rawValue);

	return {
		isSet: true,
		value: parseResult.wasSuccessful
			? parseResult.result
			: undefined
	};
}
